import { DockviewApi, DockviewPanelApi } from "dockview-react";
import React, { useEffect } from "react";
import SafeNumberInput from "./SafeNumberInput";
import { api } from "./utils/api";

interface IkkPost { 
    id: number;
    createdAt: string;
    title: string;
    selfText: string;
    upvoteRatio: number; 
    permalink: string;
}

interface IkkPostsRequest { 
    page: number; 
    search_query: string; 
    start_date: string; 
    end_date: string; 
}

const KK7766posts = (props: {
    api: DockviewPanelApi; 
    containerApi: DockviewApi;
}) => {
    const [kkPosts, setKkPosts] = React.useState<IkkPost[]>([]);
    const [kkPostRequest, setKkPostRequest] = React.useState<IkkPostsRequest>({
        page: 1,
        search_query: "",
        start_date: "2000-01-01",
        end_date: "2026-12-31"
    });
    const [errorMessage, setErrorMessage] = React.useState("");

    async function getKkPosts() {
        setErrorMessage("");

        try {
          const response = await api.get("/kk-posts", {
            params: {
              page: kkPostRequest.page,
              search_query: kkPostRequest.search_query,
              start_date: kkPostRequest.start_date,
              end_date: kkPostRequest.end_date,
            },
          });
          setKkPosts(response.data);

          // update title
          props.api.setTitle(`kk posts: ${kkPostRequest.search_query}`);
        } catch (error) {
          console.error(error);
          setErrorMessage("Error while fetching posts");
        }
    }

      const renderImgurLink = (body: string) => {
    // check for imgur links in the body similar to https://i.imgur.com/59w3ob1.png
    // and only get their ids
    // e.g. https://i.imgur.com/59w3ob1.png -> 59w3ob1.png
    const imgurRegex =
      /https:\/\/i\.imgur\.com\/([a-zA-Z0-9]+)\.(png|jpg|jpeg|gif)/g;

    let matches = [];

    for (const match of body.match(imgurRegex) ?? []) {
      if (matches.indexOf(match) !== -1) continue; // avoid duplicates

      matches.push(match);
    }

    if (matches.length === 0) {
      return <></>;
    }

    if (matches) {
      return matches.map((match) => {
        const imgurId = match.split("/").pop();
        return (
          <img
            key={imgurId}
            src={`kk7766/img/${imgurId}`}
            alt="Imgur"
            className="h-auto w-1/2"
          />
        );
      });
    }
  };

    return (
    <div className="p-2 pb-10 overflow-auto h-full">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          getKkPosts();
        }}
      >
        <label htmlFor="page">Page:</label>
        <SafeNumberInput
            id="page"
          value={kkPostRequest.page}
          onChange={(value) => setKkPostRequest({ ...kkPostRequest, page: value })}
          min={1}
        />

        <div className="form-group">
          <label htmlFor="search">Search:</label>
          <input
            type="text"
            id="search"
            value={kkPostRequest.search_query}
            onChange={(e) => setKkPostRequest({ ...kkPostRequest, search_query: e.target.value })}
            className="border rounded p-1"
          />
        </div>
       
        <div className="form-group">
          <label htmlFor="start-date">Start date:</label>
          <input
            type="text"
            id="start-date"
            value={kkPostRequest.start_date}
            onChange={(e) => setKkPostRequest({ ...kkPostRequest, start_date: e.target.value })}
            className="border rounded p-1"
          />
        </div>
  
        <div className="form-group">
          <label htmlFor="end-date">End date:</label>
          <input
            type="text"
            id="end-date"
            value={kkPostRequest.end_date}
            onChange={(e) => setKkPostRequest({ ...kkPostRequest, end_date: e.target.value })}
            className="border rounded p-1"
          />
        </div>

        <button type="submit" className="hidden">
          Load Posts
        </button>
      </form>

      {errorMessage && <p className="text-red-500">{errorMessage}</p>}

      {kkPosts.map((post, index) => (
        <div key={index} className="mb-4">
          <p className="font-semibold">{post.createdAt} Upvote ratio: {post.upvoteRatio.toFixed(2)}</p>
          <a target="_blank" rel='noopener noreferrer' href={post.permalink} className="flex flex-row gap-2 font-semibold">
            {post.title}
          </a>
           <div
            className="whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: post.selfText }}
          />

          {renderImgurLink(post.selfText)}
        </div>
      ))}
    </div>
  );
};

export default KK7766posts;
